(() => {
  if (window.HAThermalTwoPack) return;
  window.HAThermalTwoPack = true;

  function syncCartState(cart, response) {
    if (!cart || cart.tagName !== 'CART-DRAWER') return;

    const itemCount = typeof response.item_count === 'number' ? response.item_count : response.items?.length || 1;
    const isEmpty = itemCount === 0;

    cart.classList.toggle('is-empty', isEmpty);
    cart.querySelector('cart-drawer-items')?.classList.toggle('is-empty', isEmpty);
    cart.querySelector('.drawer__inner')?.classList.toggle('is-empty', isEmpty);
  }

  function mountTwoPack(root) {
    if (!root || root.dataset.haThermalTwoPackMounted === 'true') return;
    root.dataset.haThermalTwoPackMounted = 'true';

    const productsJson = root.querySelector('[data-ha-thermal-two-pack-products]');
    if (!productsJson) return;

    const products = JSON.parse(productsJson.textContent || '[]');
    const productsByHandle = new Map(products.map((product) => [product.handle, product]));
    const sectionId = root.dataset.sectionId;
    const currentHandle = root.dataset.currentHandle;
    const choices = Array.from(root.querySelectorAll('[data-ha-thermal-two-pack-choice]'));
    const status = root.querySelector('[data-ha-thermal-two-pack-status]');
    const productInfo = root.closest('product-info');

    const state = {
      loadingHandle: null,
    };

    function setStatus(message) {
      if (status) status.textContent = message || '';
    }

    function getCurrentProduct() {
      return productsByHandle.get(currentHandle);
    }

    function getCurrentVariantId() {
      const variantInput = productInfo?.querySelector(`#product-form-${sectionId} input[name="id"]`);
      return Number(variantInput?.value || 0);
    }

    function getCurrentVariant() {
      const currentProduct = getCurrentProduct();
      if (!currentProduct) return null;

      const variantId = getCurrentVariantId();
      return currentProduct.variants.find((variant) => Number(variant.id) === variantId) || currentProduct.variants[0] || null;
    }

    function getCurrentSize() {
      return getCurrentVariant()?.title || root.dataset.initialSize || '';
    }

    function getMatchingVariant(productHandle, sizeValue) {
      const product = productsByHandle.get(productHandle);
      if (!product) return null;
      return product.variants.find((variant) => variant.title === sizeValue) || null;
    }

    function render() {
      const currentSize = getCurrentSize();
      let availableChoiceCount = 0;

      choices.forEach((button) => {
        const match = getMatchingVariant(button.dataset.productHandle, currentSize);
        const unavailable = !match || !match.available;
        button.disabled = unavailable || state.loadingHandle !== null;
        button.classList.toggle('is-unavailable', unavailable);
        button.classList.toggle('is-loading', state.loadingHandle === button.dataset.productHandle);
        if (!unavailable) availableChoiceCount += 1;
      });

      if (!availableChoiceCount && !state.loadingHandle) {
        setStatus(currentSize ? `No second colors available in size ${currentSize}.` : 'No second colors available right now.');
      } else if (!state.loadingHandle) {
        setStatus('');
      }
    }

    function addPair(secondHandle) {
      if (state.loadingHandle) return;

      const currentVariant = getCurrentVariant();
      const currentSize = getCurrentSize();
      const secondVariant = getMatchingVariant(secondHandle, currentSize);

      if (!currentVariant || !secondVariant || !secondVariant.available) {
        render();
        return;
      }

      state.loadingHandle = secondHandle;
      render();
      setStatus('Adding both thermals...');

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const payload = {
        items: [
          {
            id: currentVariant.id,
            quantity: 1,
            properties: {
              _ha_bundle: 'thermal-2-pack',
              _ha_bundle_slot: 'Primary thermal',
            },
          },
          {
            id: secondVariant.id,
            quantity: 1,
            properties: {
              _ha_bundle: 'thermal-2-pack',
              _ha_bundle_slot: 'Second thermal',
            },
          },
        ],
      };

      if (cart) {
        payload.sections = cart.getSectionsToRender().map((section) => section.id);
        payload.sections_url = window.location.pathname;
        cart.setActiveElement(root.querySelector(`[data-product-handle="${secondHandle}"]`));
      }

      fetch(routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            throw new Error(response.description || response.message || 'Unable to add both thermals right now.');
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'ha-thermal-two-pack',
              cartData: response,
            });
          }

          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }

          syncCartState(cart, response);
          cart.renderContents(response);
          setStatus('Both thermals added. Automatic discount applies in bag.');
        })
        .catch((error) => {
          console.error(error);
          setStatus(error.message || 'Unable to add both thermals right now.');
        })
        .finally(() => {
          state.loadingHandle = null;
          render();
        });
    }

    root.addEventListener('click', (event) => {
      const choice = event.target.closest('[data-ha-thermal-two-pack-choice]');
      if (!choice || choice.disabled) return;

      event.preventDefault();
      addPair(choice.dataset.productHandle);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data?.sectionId === sectionId) {
          window.requestAnimationFrame(render);
        }
      });
    }

    productInfo?.addEventListener('change', () => {
      window.setTimeout(render, 0);
    });

    render();
  }

  function mountAll() {
    document.querySelectorAll('[data-ha-thermal-two-pack]').forEach(mountTwoPack);
  }

  document.addEventListener('DOMContentLoaded', mountAll);
  document.addEventListener('shopify:section:load', mountAll);
})();
